import { connectRouter } from 'connected-react-router';
import { History } from 'history';
import { combineReducers } from 'redux';
import { AnyType } from '../../interfaces';
// -----===[REDUCERS]===-----
import appReducer from './app.reducer';
import authReducer from './auth.reducer';
import messagesReducer from './messages.reducer';
import transactionReducer from './transaction.reducer';

export * from './types';

const createRootReducer = (history: History<AnyType>) =>
  combineReducers({
    app: appReducer,
    auth: authReducer,
    messages: messagesReducer,
    router: connectRouter(history),
    transaction: transactionReducer
  });

export default createRootReducer;
